module.exports = __webpack_public_path__ + "static/media/image1.0b1ace6e.png";